/**
 * 企画回別商品一覧画面の特集コードクラス
 *
 * @export FeatureCode
 * @class FeatureCode
 */
export class FeatureCode {
  constructor(
    public featureCode: string,
    public featureName: string,
    public featureCodeLabel: string // ラベル格納用
  ) {}
}
